"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedDataDefinitionJsHelperType = void 0;
var ScopedDataDefinitionJsHelperType;
(function (ScopedDataDefinitionJsHelperType) {
    /**
     * inline-js helper for solo-keyed redis items (redis.set, redis.get, etc)
     */
    ScopedDataDefinitionJsHelperType["RedisSoloItemHelper"] = "RedisSoloItemHelper";
    /**
     * inline-js helper for time-rotating lists
     */
    ScopedDataDefinitionJsHelperType["TimeRotatingListHelper"] = "TimeRotatingListHelper";
    /**
     * inline-js helper for tracking often-large object/file storage items
     * (eg, when creating presigned AWS S3 url, store what/why info before file is uploaded)
     */
    ScopedDataDefinitionJsHelperType["TrackedObjectStoreHelper"] = "TrackedObjectStoreHelper";
    /**
     * inline-js helper for resolving wsTopics
     */
    ScopedDataDefinitionJsHelperType["WsTopicHelper"] = "WsTopicHelper";
})(ScopedDataDefinitionJsHelperType = exports.ScopedDataDefinitionJsHelperType || (exports.ScopedDataDefinitionJsHelperType = {}));
//# sourceMappingURL=scoped-data-js-helper-type.js.map